module.exports = __webpack_public_path__ + "img/Group-5092.095bae38.svg";